import { type ReactNode } from 'react';
import { AlertTriangle, Calendar } from 'lucide-react';
import { BODY, Bullet, PullQuote, Section } from './rules-typography';

export function DailyGoals(): ReactNode {
  return (
    <Section title="Objetivos diarios">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          <strong className="text-text-primary">33 creadores</strong> — mínimo
          obligatorio.
        </Bullet>
        <Bullet>
          <strong className="text-text-primary">66 creadores</strong> — misión
          diaria.
        </Bullet>
        <Bullet>
          <strong className="text-text-primary">99 creadores</strong> — top
          tier, desbloquea bonuses.
        </Bullet>
      </ul>
      <p className={BODY}>Tienes 24h cada día. Reinicio diario.</p>
    </Section>
  );
}

function StrikeWarning(): ReactNode {
  return (
    <div className="flex items-start gap-sm">
      <AlertTriangle size={16} className="mt-0.5 shrink-0 text-brand-red" />
      <p className={BODY}>
        Cada strike te acerca a la expulsión. Tres strikes en una semana y
        quedas fuera.
      </p>
    </div>
  );
}

export function Strikes(): ReactNode {
  return (
    <Section title="Sistema de strikes y sanciones">
      <StrikeWarning />
      <p className={BODY}>Ganas una sanción si:</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>No llegas a 33 creadores en un día.</Bullet>
        <Bullet>
          Subes creadores que no cumplen los requisitos (ver «Cómo jugar»).
        </Bullet>
      </ul>
      <PullQuote>
        Los strikes se reinician cada semana — solo cuentan dentro de la misma
        semana.
      </PullQuote>
    </Section>
  );
}

export function VacationDays(): ReactNode {
  return (
    <Section title="Días libres">
      <div className="flex items-start gap-sm">
        <Calendar size={16} className="mt-0.5 shrink-0 text-brand-red" />
        <p className={BODY}>
          Hasta <strong className="text-text-primary">3 días libres</strong>{' '}
          totales en todo el juego.
        </p>
      </div>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Avisas con 24h de antelación, sin excepciones.</Bullet>
        <Bullet>Se notifica por WhatsApp a soporte (Luz).</Bullet>
        <Bullet>Avisado correctamente, ese día no cuenta como fallo.</Bullet>
      </ul>
    </Section>
  );
}

export function Payments(): ReactNode {
  return (
    <Section title="Pagos">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>
          Se paga <strong className="text-text-primary">cada lunes</strong>.
        </Bullet>
        <Bullet>
          Mínimo para cobrar:{' '}
          <strong className="text-text-primary">$100 acumulados</strong>.
        </Bullet>
        <Bullet>
          Si te expulsan sin llegar a $3 acumulados, no se procesa el pago
          (coste de transacción).
        </Bullet>
        <Bullet>
          Pagos en USDC. Ver el vídeo «Recibir pagos» para los 3 pasos.
        </Bullet>
      </ul>
    </Section>
  );
}
